export function slaFormat(dueAt: string | null, now: Date = new Date()): string {
  if (!dueAt) return 'No due time';
  const deltaMinutes = Math.round((Date.parse(dueAt) - now.getTime()) / 60_000);
  const overdue = deltaMinutes < 0;
  const minutes = Math.abs(deltaMinutes);
  const duration =
    minutes >= 1440
      ? `${Math.floor(minutes / 1440)} d ${Math.floor((minutes % 1440) / 60)} h`
      : minutes >= 60
        ? `${Math.floor(minutes / 60)} h${minutes % 60 ? ` ${minutes % 60} min` : ''}`
        : `${minutes} min`;
  return overdue ? `overdue by ${duration}` : `due in ${duration}`;
}
